import routes from 'netxcore@netx/core-app/routes';
import {assetProjectEnabled} from '@netx/core-asset-project/enablers';
import {appRouter} from '@netx/core-next/instance/router';

// Deferred module routes
Object.assign(routes, {
	'document(/*anything)'() {
		dispatcher.trigger('netx:load:module:pdfViewer', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:uploadAssetRequestManager
	 */
	'assets/requests(/*anything)'() {
		dispatcher.trigger('netx:load:module:uploadAssetRequestManager', {
			loadUrl: true,
		});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/attributes/metadata/maps(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:attribute:metadata:map', {
			loadUrl: true,
		});
	},
	/**
	 * @route
	 * @fires netx:load:module:audioeditor
	 */
	'audioeditor(/*anything)'() {
		dispatcher.trigger('netx:load:module:audioeditor', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:dataset
	 */
	'dataset(/*anything)'() {
		dispatcher.trigger('netx:load:module:dataset', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:imageeditor
	 */
	'imageeditor(/*anything)'() {
		dispatcher.trigger('netx:load:module:imageeditor', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:stat
	 */
	'stat(/*anything)'() {
		dispatcher.trigger('netx:load:module:stat', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/attribute/vocabularies(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:attribute:vocabulary', {
			loadUrl: true,
		});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/caches(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system:caches', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/groups(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system:groups', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/indexes(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system:indexes', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/logs(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system:logs', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/overview(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system:overview', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/portals(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system:portals', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system/properties(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system:property', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'system(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:system', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'user/attributeSets(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:attribute:set:user', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'user/integrations(/*anything)'() {
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:user:integrations', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:system
	 */
	'access(/*anything)'() {
		// NOTE: this is just piping through to the user integrations module
		if (!Netx.session?.authenticated()) {
			appRouter.back();
			return;
		}
		dispatcher.trigger('netx:load:module:user:integrations', {loadUrl: true});
	},
	/**
	 * @route
	 * @fires netx:load:module:videoeditor
	 */
	'videoeditor(/*anything)'() {
		dispatcher.trigger('netx:load:module:videoeditor', {loadUrl: true});
	},
});

// TODO: this check has to be failing given we do not have prefs yet
// we need to ensure prefs are loaded post auth before any other modules are called upon
if (assetProjectEnabled()) {
	/**
	 * @route
	 * @fires netx:load:module:project
	 */
	routes['projects(/*anything)'] = () => {
		dispatcher.trigger('netx:load:module:project', {loadUrl: true});
	};
}

export default routes;
